export const ApiRoutesNames = {
  system: '/system',
  users: '/users',
  usersLogs: '/users-logs',
  locations: '/locations',
  sports: '/sports',
  tournaments: '/tournaments',
  participants: '/participants',
  scoreTypes: '/score-types',
  events: '/events',
  eventsStatus: '/events-status',
  markets: '/markets',
  bets: '/bets',
  betsStatus: '/bets-status',
  betsSettlements: '/bets-settlements',
  authentication: '/auth',
  counters: '/counters',
  authorizations: '/authorizations',
  usersGroups: '/users-groups',
  users_groups: '/users_groups',
  usersLogsGroups: '/users-logs-groups',
  dbTasks: '/db-tasks',
  dbTasksExec: '/db-tasks/exec',
  dbTasksExecReq: '/db-tasks/exec-req',
  dbTasksUpload: '/db-tasks/upload',
  companiesGroups: '/companiesgroups',
  companies_groups: '/companies-groups',
  companies: '/companies',
  webproxy: '/webproxy/:url',
  playfieldCheckgame: '/playfield-checkgame/:id/:home/:away/:dt',

  externalprovidersBetanoDecrypt: '/externalproviders/betano/decrypt',
}
